export default __webpack_public_path__ + "media/images/images_v2/topleft-onglet-51e06fe2c73bd2b13696ab0f9d9f138f.png";